module.exports = __webpack_public_path__ + "img/poster1.6ccad059.png";